import React, { useState, useEffect } from 'react';
import { Dropdown, Layout, Menu, Modal } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { FaChevronDown } from 'react-icons/fa';
import PortalUemHeader, { mainNavTriggerClass } from '../Components/Layout/PortalUemHeader';

const { Content } = Layout;

export default function MainLayout() {
    const navigate = useNavigate();
    const location = useLocation();
    const [visible, setVisible] = useState(true);
    const [modalVisible, setModalVisible] = useState(false);

    const landingPageItems = [
        { name: "Home", href: "/" },
        {
            name: "Sobre Nós",
            href: "/sobre",
            submenu: [
                { name: "O que é Alumni", href: "/o-que-e-alumni" },
                { name: "Objectivos da Comunidade", href: "/objectivos" },
                { name: "Dia do Alumni", href: "/dia-do-alumni" },
                { name: "Fundo Alumni", href: "/fundo-alumni" }
            ]
        },
        { name: "Embaixadores", href: "/embaixadores" },
        { name: "Núcleos Alumni", href: "/nucleos" },
        { name: "Contactos", href: "/contactos" },
        { name: "Empregabilidade", href: "/empregabilidade-publico" },
        { name: "Doações", href: "/doar" },
    ];

    useEffect(() => {
        setVisible(true);
    }, [location.pathname]);

    const goLogout = () => {
        sessionStorage.clear();
        navigate('/account/login');
    };

    const isSobreActive = (item) =>
        location.pathname === item.href ||
        (item.submenu && item.submenu.some((sub) => sub.href === location.pathname));

    const mainNav = (
        <>
            {landingPageItems.map((item) =>
                item.submenu ? (
                    <Dropdown
                        key={item.href}
                        overlay={
                            <Menu className="rounded-xl border border-gray-100 shadow-lg">
                                {item.submenu.map((subItem) => (
                                    <Menu.Item key={subItem.href}>
                                        <button
                                            type="button"
                                            onClick={() => navigate(subItem.href)}
                                            className="w-full text-left text-gray-600 hover:text-uem-primary"
                                        >
                                            {subItem.name}
                                        </button>
                                    </Menu.Item>
                                ))}
                            </Menu>
                        }
                        trigger={['hover']}
                    >
                        <button type="button" className={mainNavTriggerClass(isSobreActive(item))}>
                            <span>{item.name}</span>
                            <FaChevronDown size={12} className="opacity-90" />
                        </button>
                    </Dropdown>
                ) : (
                    <button
                        key={item.href}
                        type="button"
                        onClick={() => navigate(item.href)}
                        className={mainNavTriggerClass(location.pathname === item.href)}
                    >
                        {item.name}
                    </button>
                )
            )}
            <button
                type="button"
                onClick={() => navigate("/feed")}
                className={`${mainNavTriggerClass(false)} bg-white/10 hover:bg-white/20`}
            >
                Entrar
            </button>
        </>
    );

    if (!visible) return null;

    return (
        <Layout className="w-full" style={{ minHeight: '100vh', backgroundColor: 'white' , marginBottom: '8px'}}>
            <Layout style={{ backgroundColor: 'white' }}>
                <div style={{ position: 'sticky', top: 0, zIndex: 999 }}>
                    <PortalUemHeader
                        position="relative"
                        onBrandClick={() => navigate("/")}
                        mainNav={mainNav}
                    />

                    <Modal
                        title="Sair do sistema"
                        centered
                        open={modalVisible}
                        onOk={goLogout}
                        onCancel={() => setModalVisible(false)}
                        okButtonProps={{ danger: true }}
                    >
                        <p>Deseja sair do sistema?</p>
                    </Modal>
                </div>

                <div className="flex w-full py-3">
                    <Content className="w-full">
                        <Outlet />
                    </Content>
                </div>

                <div className="w-full">
                    <div className="flex flex-row w-full px-4 py-4 border-b-2 border-gray-200 border-t-2 border-gray-200 mt-4 items-center">
                        <div className="text-xs sm:text-xs font-bold text-gray-500">
                            Copyright &copy; {new Date().getFullYear()} UEM - Todos Direitos Reservados
                        </div>
                        <div className="ml-auto">
                            <div className="text-xs font-bold mr-2 hidden sm:block text-gray-500">
                                Email: alumni@uem.ac.mz
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </Layout>
    );
}
